/**
 * Where a sign's daily rashifal reading lives: its card on the daily hub.
 *
 * Until 2026-10-25 each sign had its own page (/rashifal/<sign>/,
 * /hi/rashifal/<sign>/), with FAQ and Q&A copy ~89% alike across the 12. The
 * owner merged them into the hubs (/rashifal/, /hi/aaj-ka-rashifal/); each old
 * URL 301s to its locale's hub (crawl-policy-data.json). A redirect cannot
 * carry a fragment to a crawler and the hub's query canonicalizer drops
 * `?sign=` (middleware QUERY_CANONICAL_PAGE_PATHS), so the redirect lands on
 * the bare hub and links name the sign's card by its anchor instead.
 */

export type RashifalReadingLanguage = "en" | "hi";

/** The id of a sign's reading card on the hubs (DailyEngineRashiSection, the Hindi digest). */
export function rashiReadingId(rashi: string): string {
  return `rashi-${rashi}`;
}

/**
 * The hub a locale's daily readings live on.
 * @internal
 */
export function rashifalHubPath(language: RashifalReadingLanguage = "en"): string {
  return language === "hi" ? "/hi/aaj-ka-rashifal/" : "/rashifal/";
}

/** A sign's daily reading on its locale's hub: `/rashifal/#rashi-mesh`. */
export function rashifalReadingHref(
  rashi: string,
  language: RashifalReadingLanguage = "en"
): string {
  return `${rashifalHubPath(language)}#${rashiReadingId(rashi)}`;
}
